<template>
  <v-card flat :height="height">
    <v-flex layout align-center justify-center pt-2 pb-3>
      <span v-if="gameCategorie === 'move'">{{ $t('statsChart.nbMove') }}</span>
      <span v-if="gameCategorie === 'text'">{{
        $t('statsChart.answers')
      }}</span>
    </v-flex>
    <stats-bar-chart
      v-if="
        graphType === 'week' ||
        graphType === 'month' ||
        graphType === 'missionSummary'
      "
      :graphType="graphType"
      :labels="chartdata.labels"
      :datasets="chartdata.datasets"
    ></stats-bar-chart>
    <!-- <stats-horizontal-bar-chart
      v-else-if="graphType==='reflexionGame' && reflexionType==='text'"
      :graphType="graphType"
      :labels="chartdata.labels"
      :datasets="chartdata.datasets">
    </stats-horizontal-bar-chart> -->
    <stats-bar-chart
      v-else-if="gameCategorie === 'move'"
      :graphType="'reflexionGame'"
      :labels="chartdata.labels"
      :datasets="chartdata.datasets"
    ></stats-bar-chart>
    <stats-horizontal-bar-chart
      v-else-if="gameCategorie === 'text'"
      :graphType="'reflexionGame'"
      :labels="chartdata.labels"
      :datasets="chartdata.datasets"
    >
    </stats-horizontal-bar-chart>
    <stats-pictures
      v-else-if="gameCategorie === 'picture'"
      :datasets="graphDatas"
      :gameId="gameId"
    >
    </stats-pictures>
    <stats-pie-chart
      v-else
      :labels="chartdata.labels"
      :datasets="chartdata.datasets"
      :isMcqImage="isMcqImage"
    ></stats-pie-chart>
  </v-card>
</template>

<script>
import StatsBarChart from './StatsBarChart';
import StatsPieChart from './StatsPieChart';
import StatsHorizontalBarChart from './StatsHorizontalBarChart';
import StatsPictures from './StatsPictures';

export default {
  // camel case not kebab case
  name: 'statsCharts',
  components: {
    StatsBarChart,
    StatsPieChart,
    StatsHorizontalBarChart,
    StatsPictures,
  },
  props: {
    datas: {
      required: false,
      default: null,
    },
    labels: {
      required: false,
      default: null,
    },
    graphType: {
      required: false,
      default: null,
    },
    reflexionType: {
      required: false,
      default: null,
    },
    isMcqImage: {
      required: false,
      default: null,
    },
    gameId: {
      type: String,
      default: null,
    },
    height: {
      type: Number,
      default: 200,
    },
    gameProperties: {
      type: Object,
      default: null,
    },
  },
  methods: {
    resizeDate(date) {
      let decoupe = date.split('-');
      let newDate = decoupe[2] + ' / ' + decoupe[1];
      return newDate;
    },
  },
  computed: {
    gameCategorie() {
      if (typeof this.gameProperties === 'object') {
        return Object.keys(this.gameProperties)[0];
      }
      return null;
    },
    graphDatas() {
      if (this.gameCategorie === 'mission') {
        return [
          this.gameProperties[this.gameCategorie].data.wins,
          this.gameProperties[this.gameCategorie].data.fails,
        ];
      } else if (this.gameCategorie === 'missionSummary') {
        return {
          entries: this.gameProperties[this.gameCategorie].data.entries,
          wins: this.gameProperties[this.gameCategorie].data.wins,
        };
      } else {
        return this.gameProperties[this.gameCategorie].data;
      }
    },
    graphLabels() {
      if (this.gameCategorie === 'mcq') {
        return this.gameProperties[this.gameCategorie].labels.trueLabels.concat(
          this.gameProperties[this.gameCategorie].labels.falseLabels
        );
      } else if (this.gameCategorie === 'mission') {
        return [
          this.gameProperties[this.gameCategorie].labels.wins,
          this.gameProperties[this.gameCategorie].labels.fails,
        ];
      }

      //console.log("ret labels v", this.gameProperties[this.gameCategorie].labels)
      return this.gameProperties[this.gameCategorie].labels;
    },
    label() {
      let label = {};
      if (this.gameCategorie === 'missionSummary') {
        label.wins = this.$t('statsChart.winsLabel');
        label.entries = this.$t('statsChart.entriesLabel');
      }
      // else if (this.graphType==='week' || this.graphType==='month') { TODO PATH
      //   label.fr=this.$t('statsChart.frenchUsersLabel');
      //   label.en=this.$t('statsChart.englishUsersLabel');
      // }
      else if (this.gameCategorie === 'move' || this.gameCategorie === 'text') {
        label = this.$t('statsChart.nbUsers');
      }
      return label;
    },
    chartdata() {
      if (this.graphType === 'week' || this.graphType === 'month') {
        return {
          labels: this.graphLabels,
          datasets: [
            {
              label: 'français',
              backgroundColor: '#009999',
              data: this.graphDatas.fr,
              barPercentage: 0.5,
            },
            {
              label: 'anglais',
              backgroundColor: '#96D9A3',
              data: this.graphDatas.en,
              barPercentage: 0.5,
            },
          ],
        };
      }
      if (this.gameCategorie === 'text' || this.gameCategorie === 'move') {
        return {
          labels: this.graphLabels,
          datasets: [
            {
              label: this.label,
              backgroundColor: '#009999',
              data: this.graphDatas,
              barPercentage: 0.5,
            },
          ],
        };
      }
      if (this.gameCategorie === 'action') {
        return {
          labels: this.graphLabels,
          datasets: [
            {
              label: this.label,
              borderWidth: 3,
              borderColor: ['#FFFFFF'],
              backgroundColor: ['#96D9A3', '#DA3838'],
              data: this.graphDatas,
            },
          ],
        };
      }
      if (this.gameCategorie === 'missionSummary') {
        return {
          labels: this.graphLabels,
          datasets: [
            {
              label: this.label.wins,
              backgroundColor: '#96D9A3',
              data: this.graphDatas.wins,
              barPercentage: 0.3,
            },
            {
              label: this.label.entries,
              backgroundColor: '#009999',
              data: this.graphDatas.entries,
              barPercentage: 0.3,
            },
          ],
        };
      }
      if (this.gameCategorie === 'mission') {
        return {
          labels: this.graphLabels,
          datasets: [
            {
              label: this.label,
              borderWidth: 3,
              borderColor: ['#FFFFFF'],
              backgroundColor: ['#96D9A3', '#DA3838'],
              data: this.graphDatas,
            },
          ],
        };
      }
      if (this.gameCategorie === 'mcq') {
        let greenColors = ['#96D9A3', '#72BF3F', '#5B9933', '#43D491'];
        let redColors = ['#E50404', '#AD0000', '#E50462', '#D77008'];
        let newBackGroundColors = greenColors
          .slice(
            0,
            this.gameProperties[this.gameCategorie].labels.trueLabels.length
          )
          .concat(
            redColors.slice(
              0,
              this.gameProperties[this.gameCategorie].labels.falseLabels.length
            )
          );
        return {
          labels: this.graphLabels,
          datasets: [
            {
              label: this.label,
              borderWidth: 3,
              borderColor: ['#FFFFFF'],
              backgroundColor: newBackGroundColors,
              data: this.graphDatas,
            },
          ],
        };
      }
      return {};
    },
  },
};
</script>
